import { ApolloLink } from 'apollo-link';
import getQueryParam from 'Jsx/Utils/getQueryParam';

import customLocalStorage from 'Jsx/Utils/customLocalStorage';

const authLink = new ApolloLink((operation, forward) => {
  const newHeaders = {};

  const user = customLocalStorage.getItem('user');
  const jsonWebToken =
    user && !!JSON.parse(user)
      ? JSON.parse(user).jsonWebToken
      : getQueryParam('current_token');
  const headerAuthorization = jsonWebToken
    ? `JWT ${JSON.parse(user).jsonWebToken}`
    : '';

  if (headerAuthorization) {
    newHeaders.authorization = headerAuthorization;
  }

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      ...newHeaders,
    },
  }));

  return forward(operation);
});

export default authLink;
